







































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
} from "@/configuration";

@Component({
  metaInfo: {
    title: "RedCapital  | Plataforma de Financiamiento Digital ",
    //titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  mounted: 
  	function(){
    if (this.$route.hash) {
      //@ts-ignore
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
    // @ts-ignore
    this.onResponsive();
    // @ts-ignore
    window.addEventListener("resize", this.onResponsive);
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },
    onResponsive() {
      let w = window.innerWidth;
      if (w < 600) {
        this.$data.options.logos.perPage = 2;
      } else if (w > 600 && w < 960) {
        this.$data.options.logos.perPage = 3;
      } else if (w > 960 && w < 1264) {
        this.$data.options.logos.perPage = 4;
      } else if (w > 1264 && w < 1904) {
        this.$data.options.logos.perPage = 4;
      } else if (w > 1904) {
        this.$data.options.logos.perPage = 10;
      }
    },
  },
  beforeRouteUpdate (to, from, next) {
    if(to.hash){
      //@ts-ignore
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
    next();
  }, 
})
export default class About extends Vue {}
